

import { useEffect } from "react";
import { useMsal, useIsAuthenticated, IMsalContext } from "@azure/msal-react";
import { storeAwsSession, generateKeysApi, loadAwsSession } from "../utils/awsSession";


export function useAwsSession(enabled = true): void {
  const msalInstance = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const accounts = msalInstance.accounts;

  useEffect(() => {
    // Only run after MSAL indicates the user is signed in and an account is present
    if (!enabled || !isAuthenticated || !accounts || accounts.length === 0) return;

    let didCancel = false;

    (async () => {
      // 1) First, check if we already have an unexpired session stored
      try {
        const existing = await loadAwsSession();
        return;
      } catch {
        // missing or expired → we must fetch a fresh one
      }

      // 2) If we get here, we need to call /keys
      try {
        if (didCancel) return;

        const raw = await generateKeysApi(msalInstance);
        // raw.data.data.session per the API shape
        const session = raw.data.session;
  

        if (didCancel) return;

        await storeAwsSession(session);
      } catch (err) {
        console.error("useAwsSession: failed to fetch/store AWS session:", err);
      }
    })();

    return () => {
      didCancel = true;
    };
  // Only re-run when isAuthenticated flips true or accounts changes length
  }, [enabled, isAuthenticated, accounts.length, msalInstance]);
}
